import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

export class PersonalVerificationAnalytics extends BaseAnalytics {
    constructor(category = 'personal_verification') {
        super();
        this.category = category;
    }

    openedPersonalDataVerification() {
        this.send('open_personal_data_verification');
    }

    stepPersonalData(label: string) {
        this.send('step_personal_data', label);
    }

    enterPhoneNumber() {
        this.send('enter phone_number');
    }

    enterFio() {
        this.send('enter fio');
    }
}
